const Responsive_Course_Exam = () => {
  return (
    <div>
      <h1>Responsive Course Exam</h1>
    </div>
  );
};
export default Responsive_Course_Exam;
